import { type FC, type ReactNode, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { H1, StringSmall } from '@/components/Typography/Typography';
import { GreyBlurButton, MainButton } from '@/components/ui/Button/Button';

import { ModalContext } from '../Modal/config';

interface ProductOfDaySpinWrapperProps {
  title: string;
  subtitle: string;
  buttonText: string;
  onSpin: () => void;
  inactive?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
  children: ReactNode;
  isCompleted?: boolean;
}

const ProductOfDaySpinWrapper: FC<ProductOfDaySpinWrapperProps> = ({
  title,
  subtitle,
  buttonText,
  onSpin,
  inactive = false,
  disabled = false,
  children,
  isCompleted,
  isLoading,
}) => {
  const { t } = useTranslation();
  const { secondModal } = useContext(ModalContext);

  const handleClose = (): void => {
    secondModal.closeModal();
  };

  return (
    <div className="flex flex-col items-center pb-[4.5rem] h-full pt-[calc(var(--header-height)_+_2.5rem)] px-6">
      <div className="flex flex-col gap-1">
        <H1 weight="extrabold">{title}</H1>
        <StringSmall className="!text-white/60 text-center">
          {subtitle}
        </StringSmall>
      </div>

      {children}

      {isCompleted ? (
        <MainButton
          text={buttonText}
          onClick={onSpin}
          inactive={inactive}
          isLoading={isLoading}
          disabled={disabled}
        />
      ) : (
        <GreyBlurButton text={t('Close')} onClick={handleClose} />
      )}
    </div>
  );
};

export default ProductOfDaySpinWrapper;
